<div class="flex-center">
  <div class="contentWidth">
    <div style="height: calc(90vh - 100px); overflow-y: auto;">
      <form [formGroup]="SVCGForm" autocomplete="off">
        <ng-container formArrayName="SVCGRows">
          <table #objTable
            mat-table
            matSort
            [dataSource]="dataSource"
            class="table-add-butt-header-orange mat-elevation-z8 mat-table-custom">

            <ng-container matColumnDef="headertitle">
              <th class="title-col" mat-header-cell *matHeaderCellDef colspan="2">
                <div class="pull-left">
                  <h4>Manufacturing Line Versions</h4>
                </div>
              </th>
            </ng-container>
            <ng-container matColumnDef="headeraddbutton">
              <th class="butt-col" mat-header-cell *matHeaderCellDef>
                <div class="OrangeButton">
                  <button mat-raised-button (click)="addNewRow()"
                    matTooltip="Add Configuration" class="button-color-fix pull-right">
                    <mat-icon class="icon-color-fix icon-padding-fix">add_box</mat-icon>
                  </button>
                </div>
              </th>
            </ng-container>

            <!-- Center Product Column -->
            <ng-container matColumnDef="centerproduct">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="centerproduct" style="width:45%">Manufacturing Center Product</th>
              <td mat-cell *matCellDef="let element; let i = index" style="width:45%">
                @if (element.isEditable) {
                  <div [innerHTML]="getCenterProductText(element.manufacturingCenterProductId)"></div>
                }
                @if (!element.isEditable) {
                  <mat-form-field floatLabel="auto">
                    <mat-select style="min-width: 200px; color:red" [(ngModel)]="element.manufacturingCenterProductId"
                      [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="updateManufacturingCenterProductId(i, $event)">
                      <mat-option [value]="-1" [disabled]="true">Select</mat-option>
                      @for (cp of availableCenterProducts; track cp) {
                        <mat-option [value]="cp.manufacturingCenterProductID">
                          {{getCenterProductText(cp.manufacturingCenterProductID)}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
              </td>
            </ng-container>

            <!-- Controller Software Version Column -->
            <ng-container matColumnDef="controllersoftwareversion">
              <th mat-header-cell *matHeaderCellDef mat-sort-header="controllersoftwareversion" style="width:45%">Release Name</th>
              <td mat-cell *matCellDef="let element; let i = index" style="width:45%">
                @if (element.isEditable) {
                  <div [innerHTML]="getReleaseName(element.controllerSoftwareVersionId)"></div>
                }
                @if (!element.isEditable) {
                  <mat-form-field floatLabel="auto">
                    <mat-select style="min-width: 200px; color:red" [(ngModel)]="element.controllerSoftwareVersionId"
                      [ngModelOptions]="{standalone: true}"
                      (ngModelChange)="updateControllerSoftwareVersionId(i, $event)">
                      <mat-option [value]="-1" [disabled]="true">Select</mat-option>
                      @for (r of getFilteredControllerSoftwareReleases(); track r.controllerSoftwareVersionID) {
                        <mat-option [value]="r.controllerSoftwareVersionID">
                          {{r.releaseName}}
                        </mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="action">
              <th mat-header-cell *matHeaderCellDef style="width:10%"></th>
              <td mat-cell *matCellDef="let element" style="width:10%">
                @if (!element.isEditable) {
                  <button mat-icon-button
                    matTooltip="Cancel Changes"
                    color="warn"
                    (click)="resetRowByID(element.softwareVersionForConfigGenerationID)">
                    <mat-icon class="actionButtons">rotate_left</mat-icon>
                  </button>
                }
                @if (element.isEditable) {
                  <button mat-icon-button
                    matTooltip="Edit"
                    color="primary"
                    (click)="editRowByID(element.softwareVersionForConfigGenerationID)">
                    <mat-icon class="actionButtons">edit</mat-icon>
                  </button>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="savefooter">
              <th mat-footer-cell *matFooterCellDef colspan="4">
                <div class="OrangeButton">
                  <button mat-raised-button type="submit" (click)="onSave()"
                    [disabled]="!anyChange()"
                    [matTooltip]="anyChange()? 'Save changes' : 'Save disabled'"
                    class="button-color-fix pull-right">
                    Save
                    <mat-icon style="color:white !important" class="icon-color-fix">save</mat-icon>
                  </button>
                </div>
              </th>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="['headertitle', 'headeraddbutton']; sticky: true" class="stickyTopz100"></tr>
            <tr class="col-headers" mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: columnsToDisplay;" [class.alternative2]="!row.isEditable"></tr>
            <tr mat-footer-row *matFooterRowDef="['savefooter']; sticky: true"></tr>
          </table>
        </ng-container>
      </form>
    </div>
  </div>
</div>